export default "__VITE_ASSET__Bo6GaBY6__"